import React, { Component } from "react";
import {
  Modal,
  FormSelect,
  FormInput,
  FormTextarea,
  FormRadio,
  Button,
  Loader,
} from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";

import axiosConfig from "../../utils/axiosConfig";

export default class ModalEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      incident: "",
      solution: "",
      commentaire: "",
      impactFinancierCompagnie: "",
      impactFinancierCabinet: "",
      anomalyNotedId: "",
      anomalyOriginId: "",
      anomalyExpertiseTypeId: "",
      anomalyNotedOptions: [],
      anomalyOriginOptions: [],
      anomalyExpertiseTypeOptions: [],
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && this.props.show !== prevProps.show && this.props.item) {
      this.loadOptions();
      this.loadItemData();
    }
  }

  loadItemData = () => {
    const item = this.props.item;
    let solution = "";
    let commentaire = "";
    let impactFinancierCompagnie = "";
    let impactFinancierCabinet = "";

    if (item.data) {
      try {
        const parsed = JSON.parse(item.data);
        solution = parsed.solution || "";
        commentaire = parsed.commentaire || "";
        impactFinancierCompagnie = parsed["impact-financier-compagnie"] || "";
        impactFinancierCabinet = parsed["impact-financier-cabinet"] || "";
      } catch (e) {}
    }

    this.setState({
      incident: item.incident || "",
      solution,
      commentaire,
      impactFinancierCompagnie,
      impactFinancierCabinet,
      anomalyNotedId: item.anomalyNotedId || "",
      anomalyOriginId: item.anomalyOriginId || "",
      anomalyExpertiseTypeId: item.anomalyExpertiseTypeId || "",
    });
  };

  loadOptions = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("anomaly/get-options").then((res) => {
        if (res.data.success === true) {
          this.setState({
            isLoad: false,
            anomalyNotedOptions: res.data.anomalyNoted || [],
            anomalyOriginOptions: res.data.anomalyOrigin || [],
            anomalyExpertiseTypeOptions: res.data.anomalyExpertiseType || [],
          });
        } else {
          this.setState({ isLoad: false });
        }
      });
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    const data = {
      incident: this.state.incident,
      data: JSON.stringify({
        solution: this.state.solution,
        commentaire: this.state.commentaire,
        "impact-financier-compagnie": this.state.impactFinancierCompagnie,
        "impact-financier-cabinet": this.state.impactFinancierCabinet,
      }),
      anomalyNotedId: this.state.anomalyNotedId,
      anomalyOriginId: this.state.anomalyOriginId,
      anomalyExpertiseTypeId: this.state.anomalyExpertiseTypeId,
    };
    this.props.onUpdate(this.props.item.id, data);
  };

  render() {
    return (
      <Modal
        title="Modifier l'anomalie"
        show={this.props.show}
        onClose={this.props.onClose}
      >
        <Loader show={this.state.isLoad} />
        <Row>
          <Col xs={12} md={6}>
            <FormSelect
              className="my-10"
              title="Anomalie relevée"
              name="anomalyNotedId"
              value={this.state.anomalyNotedId}
              options={this.state.anomalyNotedOptions}
              onChange={this.handleInputChange}
              ignore={true}
              init="Sélectionner une anomalie"
            />
          </Col>
          <Col xs={12} md={6}>
            <FormSelect
              className="my-10"
              title="Origine"
              name="anomalyOriginId"
              value={this.state.anomalyOriginId}
              options={this.state.anomalyOriginOptions}
              onChange={this.handleInputChange}
              ignore={true}
              init="Sélectionner une origine"
            />
          </Col>
        </Row>
        <FormSelect
          className="my-10"
          title="Type d'expertise"
          name="anomalyExpertiseTypeId"
          value={this.state.anomalyExpertiseTypeId}
          options={this.state.anomalyExpertiseTypeOptions}
          onChange={this.handleInputChange}
          ignore={true}
          init="Sélectionner un type"
        />
        <p className="mt-10 mb-5"><b>Incident matériel</b></p>
        <FormRadio
          className="my-5"
          text="Informatique"
          name="incident"
          value="informatique"
          checked={this.state.incident === "informatique"}
          onChange={() => this.setState({ incident: "informatique" })}
        />
        <FormRadio
          className="my-5"
          text="Véhicule"
          name="incident"
          value="vehicule"
          checked={this.state.incident === "vehicule"}
          onChange={() => this.setState({ incident: "vehicule" })}
        />
        <FormRadio
          className="my-5"
          text="Autre"
          name="incident"
          value="autre"
          checked={this.state.incident === "autre"}
          onChange={() => this.setState({ incident: "autre" })}
        />
        <Row>
          <Col xs={12} md={6}>
            <FormInput
              className="my-10"
              title="Impact financier compagnie (€ HT)"
              name="impactFinancierCompagnie"
              type="number"
              value={this.state.impactFinancierCompagnie}
              onChange={this.handleInputChange}
            />
          </Col>
          <Col xs={12} md={6}>
            <FormInput
              className="my-10"
              title="Impact financier cabinet (€ HT)"
              name="impactFinancierCabinet"
              type="number"
              value={this.state.impactFinancierCabinet}
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>
        <FormTextarea
          className="my-10"
          title="Commentaire"
          name="commentaire"
          value={this.state.commentaire}
          onChange={this.handleInputChange}
        />
        <FormTextarea
          className="my-10"
          title="Proposition de solutions"
          name="solution"
          value={this.state.solution}
          onChange={this.handleInputChange}
        />
        <Button
          className="mt-10"
          text="Valider"
          onClick={this.handleSubmit}
        />
      </Modal>
    );
  }
}
